/**
 * Accordion JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Export the class reference.
 */
export default class Accordion {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.accordionHeadings = $( '.js-accordion__item-heading' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Every heading in the accordion needs to be clickable and
        // when clicked, open the hidden content under it.
        this.accordionHeadings.each( ( index, accordionHeading ) => {
            $( accordionHeading ).on( 'click', ( e ) =>  {
                this.accordionClickHandle( e, accordionHeading );
            });
        });
    }

    /**
     * Handles toggling of accordion items.
     *
     * @param {event object} e
     * @param {dom node} accordionHeading
     */
    accordionClickHandle( e, accordionHeading ) {

        Theme.Common.stop( e );

        const $accordionHeading = $( accordionHeading );
        const $accordion = $accordionHeading.parent();

        this.toggleAccordionItem( $accordion );

        $accordion.siblings( '.accordion__item--open' ).each( ( index, element ) => {
            this.toggleAccordionItem(  $( element ) );
        });
    }

    /**
     * This handles the toggling of the accordion elements' visibility and aria classes.
     *
     * @param {obj} accordionHeading jQuery object.
     */
    toggleAccordionItem( $accordion ) {
        const $accordionContent = $accordion.find( '.js-accordion__item-content' );
        const ariaExpandedState = $accordionContent.attr( 'aria-hidden' ) === 'false' ? true : false;

        $accordion.toggleClass( 'accordion__item--open' );
        $accordionContent.attr( 'aria-hidden', ariaExpandedState );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}
